import {
    CATEGORYCOURSE_BEGIN,
    CATEGORYCOURSE_ADD,
    CATEGORYCOURSE_FAILURE,
} from 'app/actions/CategoryCourseActions';

const initialState = {
    byId: {},
    allIds: [],
    isLoading: false,
};

export default function CategoryCourseReducer(state = initialState, action) {
    switch (action.type) {
        case CATEGORYCOURSE_BEGIN:
            return {
                ...state,
                isLoading: true
            }
        case CATEGORYCOURSE_ADD:
            let allIds = [...new Set(state.allIds.concat(action.payload.data.allIds))];
            let byId = {
                ...state.byId,
                ...action.payload.data.byId
            };
            return {
                ...state,
                allIds,
                byId,
                isLoading: false,
            };
        case CATEGORYCOURSE_FAILURE:
            return {
                ...state,
                isLoading: false
            }
        default:
            return state;
    }
};

export const getCategoryCourse = state => {
    return state.allIds.map(id => state.byId[id]);
}